export const SET_ALL = 'SET_ALL';
export const UPDATE_PROFILE_DATA = 'UPDATE_PROFILE_DATA';
export const UPDATE_INVESTMENT_PROFILE_DATA = 'UPDATE_INVESTMENT_PROFILE_DATA';
export const DELETE_INVESTMENT_PROFILE = 'DELETE_INVESTMENT_PROFILE';
export const SET_TRANSACTION_DATA = 'SET_TRANSACTION_DATA';
export const ADD_TRANSACTION_DATA = 'ADD_TRANSACTION_DATA';
export const LESS_TRANSACTION_DATA = 'LESS_TRANSACTION_DATA';
export const SET_TRANSACTION_STATUS_CANCELLED = 'SET_TRANSACTION_STATUS_CANCELLED';
export const SET_PROFILE_SSN = 'SET_PROFILE_SSN';
